<div class="rich-text-editor-container">
  <editor
    [init]="editorConfig"
    [ngModel]="editorContent"
    (ngModelChange)="onEditorChange($event)">
  </editor>
</div>